/*
 * Dealeasy bulk discount table: heading, per-unit prices, rolls <-> LM labels.
 * Moved from the Dealeasy app embed "custom code" (same behaviour), optimised for INP:
 * - exits immediately on pages without .product__price
 * - at most one pass per frame instead of one per DOM mutation / two per click
 * - the observer is paused while this script edits the DOM (no self-triggered loops)
 * - the selected variant is looked up inside the product, not the whole document
 */
(function () {
  if (window.__dealeasyBulkPricing) return;
  window.__dealeasyBulkPricing = true;

  var ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#474C51" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><path d="M7 7h.01"/></svg>';
  var TEXT = 'BUY MORE, PAY LESS - price applies automatically';
  var RE_1LM = /(^|[^0-9])1\s*LM\b/i;

  var roots = document.getElementsByClassName('product__price'); // live collection, cheap to check

  /* ---------- 1. Heading + table markers ---------- */
  function fixRoot(root) {
    if (root.querySelector('.omega-buymore')) return;

    // heading (text "bulk discount" or "buy more, pay less")
    var head = null;
    root.querySelectorAll('*').forEach(function (el) {
      if (el.children.length) return;
      var t = el.textContent.trim().toLowerCase();
      if (t === 'bulk discount' || t.indexOf('buy more, pay less') === 0) head = el;
    });
    if (!head) return;
    head.classList.add('omega-buymore');
    head.innerHTML = ICON + '<span>' + TEXT + '</span>';

    // app block (direct child of .product__price)
    var block = head;
    while (block.parentElement && block.parentElement !== root) block = block.parentElement;
    block.classList.add('omega-block');

    // discount table (common parent of the "X rolls" / "X meters" / "X LM" rows)
    var rows = [];
    block.querySelectorAll('*').forEach(function (el) {
      if (!el.children.length && /\b(rolls?|meters?|LM)\b/i.test(el.textContent)) rows.push(el);
    });
    if (!rows.length) return;
    var table = rows[0].parentElement;
    while (table && !table.contains(rows[rows.length - 1])) table = table.parentElement;
    if (!table) return;
    table = table.closest('table') || table;

    // if the heading sits in the same container as the rows, wrap only the rows
    if (table.contains(head)) {
      var kids = Array.prototype.slice.call(table.children).filter(function (c) {
        return !c.contains(head);
      });
      if (!kids.length) return;
      var wrap = document.createElement('div');
      table.insertBefore(wrap, kids[0]);
      kids.forEach(function (k) { wrap.appendChild(k); });
      table = wrap;
    }
    table.classList.add('omega-table');
  }

  /* ---------- 2. Price column ---------- */
  function setupRoot(root) {
    root.querySelectorAll('.omega-table').forEach(function (table) {
      if (table.querySelector('.omega-price')) return;

      var saves = [];
      table.querySelectorAll('*').forEach(function (el) {
        if (!el.children.length && /save\s*\d+\s*%/i.test(el.textContent)) saves.push(el);
      });

      saves.forEach(function (leaf) {
        var row = leaf.closest('tr');
        if (!row) {
          row = leaf;
          while (row.parentElement && row.parentElement !== table) row = row.parentElement;
        }
        if (row.querySelector('.omega-price')) return;

        var pct = parseFloat(leaf.textContent.match(/(\d+(?:[.,]\d+)?)\s*%/)[1].replace(',', '.'));

        var cells = Array.prototype.slice.call(row.children);
        var saveCell = cells.filter(function (c) { return c.contains(leaf); })[0];
        var labelCell = cells.filter(function (c) { return c !== saveCell && /(rolls?|meters?|LM)/i.test(c.textContent); })[0] || cells[0];
        if (!saveCell || !labelCell || saveCell === labelCell) return;

        var price = document.createElement(labelCell.tagName.toLowerCase());
        price.className = 'omega-price';
        price.setAttribute('data-pct', pct);
        labelCell.parentNode.insertBefore(price, labelCell.nextSibling);

        row.classList.add('omega-row');
        saveCell.classList.add('omega-save');
      });
    });
  }

  /* ---------- 3. Prices + rolls/LM labels ---------- */
  function parsePrice(txt) {
    var m = (txt || '').match(/\d[\d.,\s]*\d|\d/);
    if (!m) return null;
    var s = m[0].replace(/\s/g, '');
    var lc = s.lastIndexOf(','), ld = s.lastIndexOf('.');
    if (lc > ld) s = s.replace(/\./g, '').replace(',', '.');   // 1.210,00
    else s = s.replace(/,/g, '');                              // 1,210.00
    var n = parseFloat(s);
    return isNaN(n) ? null : n;
  }

  function fmt(n, unit) {
    return '€' + n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '/' + unit;
  }

  function labelTextFor(input) {
    var txt = (input.value || '') + ' ';
    if (input.id) {
      var l = document.querySelector('label[for="' + input.id + '"]');
      if (l) txt += l.textContent + ' ';
    }
    var pl = input.closest('label');
    if (pl) txt += pl.textContent;
    return txt;
  }

  function isMeterMode(scope) {
    var checked = scope.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');
    for (var i = 0; i < checked.length; i++) {
      if (RE_1LM.test(labelTextFor(checked[i]))) return true;
    }
    var sels = scope.querySelectorAll('select');
    for (var j = 0; j < sels.length; j++) {
      var opt = sels[j].options[sels[j].selectedIndex];
      if (opt && RE_1LM.test(opt.textContent + ' ' + opt.value)) return true;
    }
    var sel = scope.querySelectorAll(
      '[aria-checked="true"], [aria-pressed="true"], [aria-selected="true"], ' +
      '.is-selected, .selected, .active, .is-active, .checked'
    );
    for (var k = 0; k < sel.length; k++) {
      var t = sel[k].textContent || '';
      if (t.length < 80 && RE_1LM.test(t)) return true; // small variant tiles only, not containers
    }
    return false;
  }

  function swapUnitText(el, lm) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var v = node.nodeValue;
      var nv = lm
        ? v.replace(/\b(rolls?|meters?)\b/gi, 'LM')
        : v.replace(/\b1(\s+)(LM|meters?)\b/gi, '1$1roll')
           .replace(/\b(LM|meters?)\b/gi, 'rolls');
      if (nv !== v) node.nodeValue = nv;
    }
  }

  function currentPct(priceEl) {
    var row = priceEl.parentElement;
    if (!row) return null;
    var cells = row.children;
    for (var i = 0; i < cells.length; i++) {
      if (cells[i] === priceEl) continue;
      var m = (cells[i].textContent || '').match(/save\s*(\d+(?:[.,]\d+)?)\s*%/i);
      if (m) return parseFloat(m[1].replace(',', '.'));
    }
    var stored = parseFloat(priceEl.getAttribute('data-pct'));
    return isNaN(stored) ? null : stored;
  }

  function renderRoot(root) {
    var first = root.firstElementChild;
    var base = first ? parsePrice(first.textContent) : null;
    if (base === null) return;

    var scope = root.closest('product-info, form, .product, [id^="ProductInfo"], [id^="QuickView"]') || document;
    var lm = isMeterMode(scope);
    var unit = lm ? 'LM' : 'roll';

    root.querySelectorAll('.omega-price').forEach(function (el) {
      // read the current "save X%" from the row every time: Dealeasy rewrites the
      // percentages in place when the variant changes (e.g. rolls 6/8/10% -> LM 3/5/7%)
      var pct = currentPct(el);
      if (pct === null) return;
      el.setAttribute('data-pct', pct);
      var txt = fmt(base * (1 - pct / 100), unit);
      if (el.textContent !== txt) el.textContent = txt;
    });

    root.querySelectorAll('.omega-row').forEach(function (row) {
      var labelCell = row.firstElementChild;
      if (labelCell && !labelCell.classList.contains('omega-price')) {
        swapUnitText(labelCell, lm);
      }
    });
  }

  /* ---------- scheduling ---------- */
  var observer = new MutationObserver(schedule);
  var queued = false;

  function observe() {
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function run() {
    queued = false;
    if (!roots.length) return;
    observer.disconnect(); // our own edits must not re-trigger the observer
    try {
      Array.prototype.slice.call(roots).forEach(function (root) {
        fixRoot(root);
        setupRoot(root);
        renderRoot(root);
      });
    } finally {
      observer.takeRecords();
      observe();
    }
  }

  function schedule() {
    if (queued || !roots.length) return;
    queued = true;
    requestAnimationFrame(run);
  }

  // variant change: the page state updates a moment later
  function afterInteraction() {
    if (!roots.length) return;
    schedule();
    setTimeout(schedule, 250);
  }
  document.addEventListener('click', afterInteraction, true);
  document.addEventListener('change', afterInteraction, true);

  observe();
  schedule();
})();
